/* eslint no-underscore-dangle: 0 */
/* eslint no-restricted-globals: 0 */
/* eslint  jsx-a11y/click-events-have-key-events: 0 */
import { InputField, View } from '@fairygodboss/ui';
import axios from 'axios';
import React from 'react';

import Tag from './TagIcon/Tag';
import { styles } from './TypeAheadStyles';

const ENTER_KEY = 13;
const UP_KEY = 38;
const DOWN_KEY = 40;
const ITEM_ALREADY_ADDED_ERROR = 'You\'ve already selected  Please select another one.';

export default class Typeahead extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            filteredSuggestions: [],
            selectedSuggestionIndex: 0,
            shouldShowSuggestions: false,
            // eslint-disable-next-line @typescript-eslint/no-shadow
            userInput: ((props) => {
                if (
                    props.isMulti
                    || !(props.selectedSuggestions && props.selectedSuggestions[0])
                ) {
                    return '';
                }

                if (props.selectedSuggestions[0].parent) {
                    return props.selectedSuggestions[0].parent.name;
                }

                return props.selectedSuggestions[0].name;
            })(props),
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    // for clicking outside of dropdown
    setWrapperRef = (node) => {
        this.wrapperRef = node;
    };

    handleClickOutside = () => {
        if (
            this.state.shouldShowSuggestions
            && this.wrapperRef
            && !this.wrapperRef.contains(event.target)
        ) {
            this.setState({ shouldShowSuggestions: false });
        }
    };

    // set filteredSuggestions according to how parent wrapper wants suggestion obj to be
    mapKeysInSuggestion = (suggestions) => suggestions && suggestions.map(this.props.setUserInput);

    handleChange = async (event) => {
        const userInput = event.target.value;

        this.props.onChange(userInput);

        if (this.props.fetchSuggestionsApi) {
            this.setState({ userInput });

            if (typeof this._source !== typeof undefined) {
                this._source.cancel();
            }

            // save the new request for cancellation
            this._source = axios.CancelToken.source();
            const cancelToken = { cancelToken: this._source.token };

            const results = userInput.length
                ? await axios.get(
                    `${this.props.fetchSuggestionsApi}/${userInput}`,
                    cancelToken
                )
                : {};

            const mappedSuggestions = this.props.setUserInput
                ? this.mapKeysInSuggestion(results.data)
                : results.data;

            this.setState({
                selectedSuggestionIndex: 0,
                filteredSuggestions: mappedSuggestions || [],
                shouldShowSuggestions: !!userInput,
            });
        }
    };

    handleSelectSuggestion = (selectedSuggestion) => {
        const newObject = {
            ...selectedSuggestion,
            option: selectedSuggestion.parent
                ? selectedSuggestion.parent.name
                : selectedSuggestion.name,
        };

        this.setState(
            {
                selectedSuggestionIndex: 0,
                filteredSuggestions: [],
                userInput: this.props.isMulti ? '' : newObject,
                shouldShowSuggestions: false,
            },
            () => this.handleSelectMultiple(newObject)
        );
    };

    handleSelectMultiple = (newObject) => {
        if (this.props.isMulti) {
            const isItemAddedAlready = this.props.selectedSuggestions.some(
                ({ id }) => id === newObject.id
            );

            if (!isItemAddedAlready) {
                const updatedSelectedSuggestions = [
                    ...this.props.selectedSuggestions,
                    newObject,
                ];
                this.props.onSelect(updatedSelectedSuggestions);
            } else {
                this.props.onError(ITEM_ALREADY_ADDED_ERROR);
            }

            return;
        }

        this.props.onSelect(newObject);
    };

    handleKeyDown = async (event) => {
        const { keyCode } = event;
        const { selectedSuggestionIndex } = this.state;
        const { filteredSuggestions } = this.state;

        const enterKeys = [ENTER_KEY];
        if (enterKeys.includes(keyCode)) {
            if (selectedSuggestionIndex >= filteredSuggestions.length) {
                await this.handleAddNewItem();
                return;
            }

            const selectedItem = filteredSuggestions[selectedSuggestionIndex];
            this.handleSelectSuggestion(selectedItem);
            event.preventDefault();
        } else if (keyCode === UP_KEY) {
            if (selectedSuggestionIndex === 0) return;

            this.setState(
                (previousState) => ({
                    selectedSuggestionIndex:
                        previousState.selectedSuggestionIndex - 1,
                }),
                this.handleScroll
            );
        } else if (keyCode === DOWN_KEY) {
            if (selectedSuggestionIndex === filteredSuggestions.length) return;

            this.setState(
                (previousState) => ({
                    selectedSuggestionIndex:
                        previousState.selectedSuggestionIndex + 1,
                }),
                this.handleScroll
            );
        }
    };

    handleScroll = () => {
        const selection = document.querySelector('.suggestion-active');

        if (selection) {
            selection.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start',
            });
        }
    };

    handleMouseOver = (index) => () => {
        this.setState({ selectedSuggestionIndex: index });
    };

    handleAddNewItem = async () => {
        if (this.state.userInput.length > this.props.inputMaxLength) {
            return;
        }

        const payload = { name: this.state.userInput };
        const { createNewItemApi } = this.props;

        if (!createNewItemApi) {
            this.handleSelectSuggestion(this.props.setUserInput(payload));
            return;
        }

        try {
            const result = (await axios.post(createNewItemApi, payload)) || {};
            const newItem = result.data.data || {};

            this.handleSelectSuggestion(this.props.setUserInput(newItem));
        } catch (error) {
            this.props.onError('Something went wrong. Please try again.');
        }
    };

    handleRemoveItem = (item) => {
        const updatedItems = this.props.selectedSuggestions.filter(
            ({ id }) => id !== item.id
        );
        this.props.onSelect([...updatedItems]);
    };

    // whether to show add new option if input is not in suggestions already
    isInputInFilteredSuggestions = (input) => this.state.filteredSuggestions.every(({ option }) => option !== input);

    renderSuggestions = () => {
        const input = this.state.userInput.option || this.state.userInput;

        const showAddNewOption = this.props.allowAddNewItem
            && this.isInputInFilteredSuggestions(input);
        const addNewOptionActiveCss = this.state.filteredSuggestions.length
            === this.state.selectedSuggestionIndex
            ? 'suggestion-active'
            : '';

        return (
            <section className="suggestion-box">
                {this.state.filteredSuggestions.map(
                    this.renderSuggestionOption
                )}

                {showAddNewOption && (
                    <View
                        className={`suggestion-option add-selection ${addNewOptionActiveCss}`}
                        onClick={this.handleAddNewItem}
                        onMouseOver={this.handleMouseOver(
                            this.state.filteredSuggestions.length
                        )}
                        css={{
                            cursor: 'pointer',
                        }}
                    >
                        Add
                        {' '}
                        {this.state.userInput.option || this.state.userInput}
                    </View>
                )}
            </section>
        );
    };

    renderSuggestionOption = (suggestion, index) => {
        const activeCssClass = index === this.state.selectedSuggestionIndex
            ? 'suggestion-active'
            : '';

        return (
            <View
                className={`suggestion-option ${activeCssClass}`}
                key={`suggestion-${index}`}
                onClick={() => this.handleSelectSuggestion(suggestion)}
                onMouseOver={this.handleMouseOver(index)}
                css={{
                    cursor: 'pointer',
                }}
            >
                {suggestion.option}
            </View>
        );
    };

    renderTags = () => {
        const withTags = this.props.selectedSuggestions;
        const { selectedSuggestions } = this.props;
        const useTags = withTags && !!selectedSuggestions.length;

        return (
            <>
                {useTags ? (
                    <div className="tags-container">
                        {this.props.selectedSuggestions.map((item) => (
                            <Tag
                                key={`${item.option}`}
                                onRemove={() => this.handleRemoveItem(item)}
                                tagCssClass="item-tags"
                                svgCssClass="item-remove-icon"
                            >
                                {item.option}
                            </Tag>
                        ))}
                    </div>
                ) : (
                    <></>
                )}
            </>
        );
    };

    preventSubmit = (e) => {
        const enterKeys = [ENTER_KEY];
        if (enterKeys.includes(e.keyCode)) {
            e.preventDefault();
        }
    };

    render() {
        const { inputId } = this.props;
        return (
            <div className="component-Input-Typeahead" ref={this.setWrapperRef}>
                <style jsx>
                    {`
                        ${styles}
                    `}
                </style>
                <InputField
                    name="typeahead"
                    changeHandler={this.handleChange}
                    placeholder={this.props.placeholderText}
                    onKeyDown={this.handleKeyDown}
                    onKeyUp={this.preventSubmit}
                    value={this.state.userInput.option || this.state.userInput}
                    autoComplete={this.props.autoComplete}
                    data-qa={this.props.qaDataAttr}
                    className={this.props.cssClass}
                    id={inputId}
                />
                {this.state.shouldShowSuggestions && this.renderSuggestions()}

                {this.renderTags()}
            </div>
        );
    }
}
